/* Copyright (c) 2020-present CloudIO Inc */

import {
  AnalyzeContext,
  AnalyzeIssue,
  AnalyzeResult,
} from 'layout/Sidebar/panels/TreeView/AnalyzeUtils';
import { isEmpty } from 'utils/isEmpty';
import { Item } from '../../registry/Component.type';

export async function analyzeActionSwitch({
  platform,
  appUid,
  pageId,
  itemId,
  mgr,
}: AnalyzeContext): Promise<AnalyzeResult> {
  const alerts: AnalyzeIssue[] = [];
  const autoFixes: (() => void)[] = [];
  const page = platform.getPage(appUid, pageId);
  if (!page) {
    return null;
  }
  const cases = platform.getChildrenOfTypeById(
    appUid,
    pageId,
    itemId,
    'ActionSwitchCase',
  );

  const switchAction = page[itemId] as Item<'ActionSwitch'>;

  if (
    typeof switchAction.props.expression !== 'object' ||
    isEmpty(switchAction.props.expression.value)
  ) {
    alerts.push({
      key: `missing-exp-${itemId}`,
      showItemId: itemId,
      alert: 'Switch expression not defined!',
      itemId,
    });
  }

  if (cases.length === 0) {
    alerts.push({
      key: `no-children-${itemId}`,
      showItemId: itemId,
      alert: `${mgr.name} has cases defined!`,
      itemId,
    });
    return [alerts, autoFixes];
  }

  const emptyCase = cases.find((c) => isEmpty(c.props.caseValue));
  if (emptyCase && cases.indexOf(emptyCase) !== cases.length - 1) {
    alerts.push({
      key: `empty-case-${itemId}`,
      showItemId: emptyCase.itemId,
      alert: 'Empty case must be the last child!',
      itemId,
    });
  }

  return [alerts, autoFixes];
}
